/* Barra flotante de colección — Treino */
(function () {
  var bar = document.getElementById('TreinoBar');
  var cfgEl = document.getElementById('TreinoBarConfig');
  if (!bar || !cfgEl || bar.dataset.ready) return;
  bar.dataset.ready = '1';
  var cfg = JSON.parse(cfgEl.textContent);
  var toolbar = document.querySelector(cfg.toolbarSelector);

  /* ---------- Menús (categorías / ordenar) ---------- */
  var toggles = bar.querySelectorAll('[data-tb-toggle]');

  function closeMenus(except) {
    toggles.forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      document.getElementById(btn.dataset.tbToggle).hidden = true;
    });
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var menu = document.getElementById(btn.dataset.tbToggle);
      var open = menu.hidden;
      closeMenus(btn);
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  document.addEventListener('click', function (e) {
    if (!bar.contains(e.target)) closeMenus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenus();
  });

  // Ir a la categoría elegida aunque el tema intercepte los clics de los links
  bar.querySelectorAll('.tb__menu a[href]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      e.stopPropagation();
      closeMenus();
      window.location.assign(link.href);
    }, true);
  });

  bar.querySelectorAll('[data-tb-sort]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', btn.dataset.tbSort);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Zoom y P·M: copias de los botones del tema ---------- */
  var mirrors = [];
  bar.querySelectorAll('[data-tb-mirror]').forEach(function (group) {
    var originals = toolbar ? toolbar.querySelectorAll(group.dataset.tbMirror) : [];
    if (!originals.length) return;
    group.hidden = false;

    originals.forEach(function (original) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tb__seg-btn';
      var imageMode = original.dataset.imageToggle;
      if (imageMode) {
        // P·M del tema → "Prenda" · "Modelo"
        btn.textContent = cfg.imageLabels[imageMode] || original.textContent.trim();
        btn.classList.add('tb__seg-btn--text');
      } else {
        btn.textContent = original.textContent.trim();
        btn.setAttribute('aria-label', btn.textContent + ' por fila');
      }

      btn.addEventListener('click', function () {
        closeMenus();
        if (original.classList.contains('is-active')) return;
        original.click();
      });

      group.appendChild(btn);
      mirrors.push({ btn: btn, original: original });
    });
  });

  function sync() {
    mirrors.forEach(function (m) {
      m.btn.setAttribute('aria-pressed', String(m.original.classList.contains('is-active')));
    });
  }
  sync();
  if (toolbar && mirrors.length) {
    new MutationObserver(sync).observe(toolbar, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  /* ---------- Ocultar la barra solo cuando ya pasaste todos los productos ---------- */
  // Con pocos productos el footer se ve de entrada, así que nos guiamos por la grilla, no por el footer.
  var grid = document.querySelector('.product-list') || (toolbar && toolbar.parentElement);
  if (grid && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      bar.classList.toggle('is-hidden', passed);
      if (passed) closeMenus();
    }).observe(grid);
  }
})();